// Which shell the app is running in.
//
// The Android app on Google Play is a Trusted Web Activity: the same site,
// wrapped, rendered by Chrome. Almost nothing should care which one it is, but
// Play's Payments policy does — see canCheckout() in lib/billing.js.

// Chrome sets an android-app:// referrer on the navigation that launches a TWA,
// and that is the only signal we get. It is only on that first navigation, so
// it has to be remembered: any client-side route change or reload loses it.
//
// sessionStorage rather than localStorage on purpose. A TWA shares Chrome's
// storage for the origin, so a persisted flag would follow the user out into
// ordinary browsing on the same device and hide the upgrade buttons there too.
const KEY = 'mimique.androidApp';

const remembered = () => {
    try {
        return sessionStorage.getItem(KEY) === '1';
    } catch (err) {
        return false;   // Storage blocked. The referrer check still stands on its own.
    }
};

const remember = () => {
    try {
        sessionStorage.setItem(KEY, '1');
    } catch (err) {
        /* Storage blocked. Detection falls back to the referrer each time. */
    }
};

// The Play Store app's package name, e.g. 'app.mimique.twa'. Null until the
// app exists, which switches detection off entirely.
//
// It has to be OUR package, not any android-app:// referrer. Tapping a link
// in Gmail, Instagram or Facebook on Android sets one too, and matching those
// flagged ordinary web visitors as Play users and hid their upgrade buttons.
const PLAY_PACKAGE_ID = null;

let cached = null;

/** True when running inside the Play Store Android app rather than a browser. */
export const isAndroidApp = () => {
    if (cached !== null) return cached;
    if (!PLAY_PACKAGE_ID) return (cached = false);
    const launched = (document.referrer || '') === `android-app://${PLAY_PACKAGE_ID}`
        || (document.referrer || '').startsWith(`android-app://${PLAY_PACKAGE_ID}/`);
    cached = launched || remembered();
    if (cached) remember();
    return cached;
};
